export const loadGoogleMapsScript = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    const googleMapKey = process.env.REACT_APP_google_map_api ?? "";
    const src: string = `https://maps.googleapis.com/maps/api/js?key=${googleMapKey}&libraries=places`;

    // If already loaded, resolve immediately
    /* if (window.google && window.google.maps) {
      resolve();
      return;
    } */

    // 🔍 Check existing scripts
    const existingScript = document.querySelector(
      `script[src="${src}"]`
    ) as HTMLScriptElement | null;

    console.log(`existingScript`, existingScript);
    if (existingScript) {
      if (existingScript.dataset.loaded === "true") {
        resolve();
      } else {
        existingScript.addEventListener("load", () => resolve());
      }
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.defer = true;

    script.dataset.loaded = "false";

    script.onload = () => {
      script.dataset.loaded = "true";
      resolve();
    };

    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));

    document.head.appendChild(script);
  });
};
